"use client";

import dynamic from "next/dynamic";

const STT = dynamic(() => import("./STT").then(mod => mod.STT));
export const STTRealtimeDemo = dynamic(() => import("./STT").then(mod => mod.STTRealtimeDemo));
export const STTOmniboxSlides = dynamic(() => import("./STTOmniboxSlides").then(mod => mod.STTOmniboxSlides));

export default STT;
